import { defaultInitialState, loadingState, updatedState, getErrorState } from '../utils';
import { PAYMENT_UPDATE, PAYMENT_UPDATE_DONE, PAYMENT_UPDATE_ERROR, PAYMENT_UPDATE_RESET } from './actionTypes';
const initialState = defaultInitialState;
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PAYMENT_UPDATE:
            return Object.assign(Object.assign({}, state), loadingState);
        case PAYMENT_UPDATE_DONE:
            return Object.assign(Object.assign({}, state), updatedState);
        case PAYMENT_UPDATE_ERROR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case PAYMENT_UPDATE_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map